<template>
	<div>
		<modal-box @close="onClose" :header="header" :subHeader="$t('readings.general.alert_reports')">
			<div slot="buttons">
				<router-link :to="{ name: resumeRouteName }">{{ $t('buttons.general.resume') }}</router-link>
				<router-link :to="{ name: historyRouteName }">{{ $t('buttons.general.history') }}</router-link>
				<router-link :to="{ name: responseRouteName }">{{ $t('buttons.general.response') }}</router-link>
			</div>
			<router-view/>
		</modal-box>
	</div>
</template>

<script>
import Readings from '@/utils/readings'
export default {
	props: [
		'user_uid',
		'watch_id',
		'type_id'
	],
	data () {
		return {
			componentName: 'watch biometric alert history view',
			header: ''
		}
	},
	watch: {
		'$route': {
			handler (to, from) {
				switch (to.name) {
					case 'WatchBiometricAlertViewResumeV2':
					case 'WatchGeofencingAlertViewResumeV2':
						this.header = this.$t('headers.general.resume')
						break
					case 'WatchBiometricAlertViewHistoryV2':
					case 'WatchGeofencingAlertViewHistoryV2':
						this.header = this.$t('headers.general.history')
						break
					case 'WatchBiometricAlertViewResponseV2':
					case 'WatchGeofencingAlertViewResponseV2':
						this.header = this.$t('headers.general.response')
						break
					default:
						this.header = ''
				}
			},
			immediate: true
		}
	},
	computed: {
		type () {
			return Readings.readingTypes.get(this.type_id).route
		},
		isGeofencing () {
			return parseInt(this.type_id) === Readings.TYPE_GEOFENCING
		},
		resumeRouteName () {
			return this.isGeofencing ? 'WatchGeofencingAlertViewResumeV2' : 'WatchBiometricAlertViewResumeV2'
		},
		historyRouteName () {
			return this.isGeofencing ? 'WatchGeofencingAlertViewHistoryV2' : 'WatchBiometricAlertViewHistoryV2'
		},
		responseRouteName () {
			return this.isGeofencing ? 'WatchGeofencingAlertViewResponseV2' : 'WatchBiometricAlertViewResponseV2'
		},
		backRouteName () {
			return this.isGeofencing ? 'WatchGeofencing' : 'WatchBiometricView'
		}
	},
	methods: {
		onClose () {
			this.$router.push({ name: this.backRouteName, params: { user_uid: this.user_uid, watch_id: this.watch_id, type: this.type } })
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/alertsV2/ReadingsAlertView.vue